import script from "./CardNameTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardNameTitle.vue?vue&type=script&setup=true&lang=ts"

import "./CardNameTitle.vue?vue&type=style&index=0&id=601b9b8c&lang=scss&scoped=true"
script.__scopeId = "data-v-601b9b8c"

export default script